import Vue from 'vue';
const $t = Vue.i18n.translate;

export default () => [
    { value: null, disabled: true, text: $t('data.experience.(Seleccionar)', '(Seleccionar)') },
    { value: "No Requerida", text: $t('data.experience.No Requerida', 'No Requerida') },
    { value: "Al menos 1 año", text: $t('data.experience.Al menos 1 año', 'Al menos 1 año') },
    { value: "Al menos 2 años", text: $t('data.experience.Al menos 2 años', 'Al menos 2 años') },
    { value: "Al menos 3 años", text: $t('data.experience.Al menos 3 años', 'Al menos 3 años') },
    { value: "Al menos 4 años", text: $t('data.experience.Al menos 4 años', 'Al menos 4 años') },
    { value: "Más de 5 años", text: $t('data.experience.Más de 5 años', 'Más de 5 años') },
    { value: "Más de 10 años", text: $t('data.experience.Más de 10 años', 'Más de 10 años') },
];
